// extracted by mini-css-extract-plugin
module.exports = {"all":"GameOver_all__-Nhvv","body":"GameOver_body__3wxBE","title":"GameOver_title__3-WKO"};